export default "__VITE_ASSET__jeBz$uKE__"